import { useCallback } from "react";
import { useAnalytics } from "../contexts/AnalyticsContext";

type Metadata = Record<string, string | number | boolean | null | undefined>;

type TrackFunction = (
  buttonNameOrMetadata: string | Metadata,
  metadata?: Metadata,
) => void;

export const useTrackButtonClick = (
  presetButtonName?: string,
  presetMetadata: Metadata = {},
): TrackFunction => {
  const { logEvent } = useAnalytics();

  return useCallback<TrackFunction>(
    (buttonNameOrMetadata, maybeMetadata) => {
      let buttonName: string;
      let metadata: Metadata = { ...presetMetadata };

      if (presetButtonName) {
        buttonName = presetButtonName;

        if (
          typeof buttonNameOrMetadata === "object" &&
          buttonNameOrMetadata !== null
        ) {
          metadata = { ...presetMetadata, ...buttonNameOrMetadata };
        }
      } else if (typeof buttonNameOrMetadata === "string") {
        buttonName = buttonNameOrMetadata;
        metadata = { ...presetMetadata, ...(maybeMetadata || {}) };
      } else {
        buttonName = "UNKNOWN_BUTTON";
        metadata = { ...presetMetadata, ...(buttonNameOrMetadata || {}) };
      }

      try {
        logEvent({
          event: "BUTTON_CLICK",
          button: buttonName,
          metadata,
        } as any);
      } catch (error) {
        console.warn("Failed to track button click:", error);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO(eslint-baseline): address react-hooks/exhaustive-deps
    [logEvent, presetButtonName],
  );
};
